module.exports = __webpack_public_path__ + "static/img/model-bg33.cf3092a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg33.jpg
// module id = ZiTs
// module chunks = 0